import { last } from './array';
import { DAYS_IN_A_WEEK, MAX_WEEKS_IN_A_MONTH } from '../constants';
import { addDays, eachDayOfInterval, endOfMonth, endOfWeek, getWeeksInMonth, startOfMonth, startOfWeek } from 'date-fns';

export function getDays(month, weekStartsOn, fixedWeeks) {
	let lastDayOfMonth = endOfMonth(month);
	let firstDayOfMonth = startOfMonth(month);
	let weeksInMonth = getWeeksInMonth(month, { weekStartsOn });

	let dates = eachDayOfInterval({
		end: endOfWeek(lastDayOfMonth, { weekStartsOn }),
		start: startOfWeek(firstDayOfMonth, { weekStartsOn }),
	});

	if (fixedWeeks && (weeksInMonth < MAX_WEEKS_IN_A_MONTH)) {
		let currentNumberOfDays = dates.length;
		let requiredNumberOfDays = DAYS_IN_A_WEEK * MAX_WEEKS_IN_A_MONTH;
		let numberOfDaysToAdd = requiredNumberOfDays - currentNumberOfDays;

		let lastDate = last(dates);

		dates.push(...eachDayOfInterval({
			start: addDays(lastDate, 1),
			end: addDays(lastDate, numberOfDaysToAdd),
		}));
	}

	return dates;
}
